export let createFilter = filter => {
  return ImageData =>{
    const data = ImageData.data;
    for (let i = 0; i < data.length; i += 4) {
      const rgb = data.subarray(i, i + 3);

      const filtered = filter(...rgb);
      rgb[0] = filtered[0];
      rgb[1] = filtered[1];
      rgb[2] = filtered[2];


    }
  }

}
